import type PlainDate from '@Domain/PlainDate';

/** Share of the limit (in percent) at the end of the month if the pace of the month so far holds. */
const projectMonthEnd = (percentSoFar: number, today: PlainDate): number => {
	const daysInMonth = new Date(today.year, today.month, 0).getDate();

	return (percentSoFar / today.day) * daysInMonth;
};

export default projectMonthEnd;
